import { getConfig } from '../Config/ApplicationConfig';
import { useSignalR } from '../Hooks/useSignalR';
export function useScriptAcceptedSignalR(config) {
    return useSignalR({
        endPointGroupName: ("Encounter-" + config.encounter.authoringSystem + "-" + config.encounter.authoringSystemForeignKey).toLowerCase(),
        endPointHub: 'ScriptAcceptedOnScriptExchange',
        endPointUrl: getConfig().apiEndpoints.medicationsManagement,
        onSignalResponse: config.onSignalResponse
    });
}
export function useScriptDeclinedSignalR(config) {
    return useSignalR({
        endPointGroupName: ("Encounter-" + config.encounter.authoringSystem + "-" + config.encounter.authoringSystemForeignKey).toLowerCase(),
        endPointHub: 'ScriptDeclinedByScriptExchange',
        endPointUrl: getConfig().apiEndpoints.medicationsManagement,
        onSignalResponse: config.onSignalResponse
    });
}
export function useScriptRedeliverSignalR(config) {
    return useSignalR({
        endPointGroupName: ("Encounter-" + config.encounter.authoringSystem + "-" + config.encounter.authoringSystemForeignKey).toLowerCase(),
        endPointHub: 'RedeliverScriptToScriptExchange',
        endPointUrl: getConfig().apiEndpoints.medicationsManagement,
        onSignalResponse: config.onSignalResponse
    });
}
export function useScriptExpiredSignalR(config) {
    return useSignalR({
        endPointGroupName: ("Encounter-" + config.encounter.authoringSystem + "-" + config.encounter.authoringSystemForeignKey).toLowerCase(),
        endPointHub: 'ScriptExpiredOnScriptExchange',
        endPointUrl: getConfig().apiEndpoints.medicationsManagement,
        onSignalResponse: config.onSignalResponse
    });
}
